import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaButtonToggle from './VaButtonToggle.vue'

export const VaButtonToggle = withConfigTransport(_VaButtonToggle)

export * from './types'
